import { app } from '../../app.module'
/**
 * ブランド情報管理用のサービス
 * @param  {Function} Restangular Restangular
 * @param  {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function EditBrandModal(Restangular, $q) {
  /**
   * getBrandById ブランド名、大カテゴリ、小カテゴリをキーにブランドを取得
   * @param {brandId}  ブランドID
   * @return {Object} ブランド情報
   */
  function getBrandById(brandId: number) {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()
    const getUrl = `/brand/getBrandById?brandId=${brandId}`

    // 設定したブランドIDでブランド情報を取得
    Restangular.all(getUrl)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data[0])
      })
    // promiseの結果を返す
    return deferred.promise
  }

  /**
   * getFbAccountByBrandId 対象ブランドのFacebookアカウント一覧を取得
   * @param {brandId} ブランドID
   * @return {Object} アカウント情報一覧
   */
  function getFbAccountByBrandId(brandId: number) {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()
    const getUrl = `/brand/getFbAccountByBrandId?brandId=${brandId}`

    // 設定したブランドIDでアカウント一覧を取得
    Restangular.all(getUrl)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })
    // promiseの結果を返す
    return deferred.promise
  }

  /**
   * getTwAccountByBrandId キーにブランドのTwitterアカウント一覧を取得
   * @param {brandId} ブランドID
   * @return {Object} アカウント情報一覧
   */
  function getTwAccountByBrandId(brandId: number) {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()
    const getUrl = `/brand/getTwAccountByBrandId?brandId=${brandId}`

    // 設定したブランドIDでアカウント一覧を取得
    Restangular.all(getUrl)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })
    // promiseの結果を返す
    return deferred.promise
  }

  /**
   * getInAccountByBrandId 対象ブランドのInstagramアカウント一覧を取得
   * @param {brandId} ブランドID
   * @return {Object} アカウント情報一覧
   */
  function getInAccountByBrandId(brandId: number) {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()
    const getUrl = `/brand/getInAccountByBrandId?brandId=${brandId}`

    // 設定したブランドIDでアカウント一覧を取得
    Restangular.all(getUrl)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })
    // promiseの結果を返す
    return deferred.promise
  }

  /**
   * getTtAccountByBrandId 対象ブランドのTiktokアカウント一覧を取得
   * @param {brandId} ブランドID
   * @return {Object} アカウント情報一覧
   */
  function getTtAccountByBrandId(brandId: number) {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()
    const getUrl = `/brand/getTtAccountByBrandId?brandId=${brandId}`

    // 設定したブランドIDでアカウント一覧を取得
    Restangular.all(getUrl)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })
    // promiseの結果を返す
    return deferred.promise
  }

  /**
   * 対象ブランドのYoutubeアカウント一覧を取得
   * @param {brandId} ブランドID
   * @return {Object} アカウント情報一覧
   */
  function getYtAccountByBrandId(brandId: number) {
    const deferred = $q.defer()
    const getUrl = `/brand/getYtAccountByBrandId?brandId=${brandId}`

    // 設定したブランドIDでアカウント一覧を取得
    Restangular.all(getUrl)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })
    return deferred.promise
  }

  /**
   * 対象ブランドのLineアカウント一覧を取得
   * @param {brandId} ブランドID
   * @return {Object} アカウント情報一覧
   */
  function getLineAccountByBrandId(brandId: number) {
    const deferred = $q.defer()
    const getUrl = `/brand/getLineAccountByBrandId?brandId=${brandId}`

    // 設定したブランドIDでアカウント一覧を取得
    Restangular.all(getUrl)
      .getList()
      .then((result) => {
        deferred.resolve(result[0].data)
      })
    return deferred.promise
  }

  /**
   * ブランド情報を保存
   * @param brandInfo ブランド情報
   * @return サーバーからの結果
   */
  function saveBrand(brandInfo: {
    brandId: number
    brandName: string
    groupIds: {}[]
    categoryName: string
    subCategoryName: string
    userId: string
  }) {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()
    // POST用のデータをセット
    const brandData = {
      brandId: brandInfo.brandId,
      name: brandInfo.brandName,
      groupIds: brandInfo.groupIds,
      brandCategoryName: brandInfo.categoryName,
      brandSubCategoryName: brandInfo.subCategoryName,
      userId: brandInfo.userId,
    }

    const saveUrl = '/brand/saveBrandInfo'

    Restangular.all(saveUrl)
      .post(brandData)
      .then((result) => {
        // エラーがない場合
        if (result[0].data.error === undefined) {
          deferred.resolve(result[0].data)
        }
      })
    // promiseの結果を返す
    return deferred.promise
  }

  /**
   * ブランドを削除する
   * @param brandId ブランドId
   * @return サーバーからの結果
   */
  function deleteBrandById(brandId: number) {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()
    // POST用のデータをセット
    const postData = {
      brandId: brandId,
    }

    const postUrl = '/brand/deleteBrandById'

    Restangular.all(postUrl)
      .post(postData)
      .then((result) => {
        if (result[0].data.error === undefined) {
          deferred.resolve(result)
        }
      })
    // promiseの結果を返す
    return deferred.promise
  }

  return {
    // ブランド情報取得
    getBrandById: getBrandById,
    // ブランドのFacebookアカウント情報取得
    getFbAccountByBrandId: getFbAccountByBrandId,
    // ブランドのTwitterアカウント情報取得
    getTwAccountByBrandId: getTwAccountByBrandId,
    // ブランドのInstagramアカウント情報取得
    getInAccountByBrandId: getInAccountByBrandId,
    // ブランドのTiktokアカウント情報取得
    getTtAccountByBrandId: getTtAccountByBrandId,
    // ブランドのYoutubeアカウント情報取得
    getYtAccountByBrandId: getYtAccountByBrandId,
    // ブランドのLineアカウント情報取得
    getLineAccountByBrandId: getLineAccountByBrandId,
    // ブランド情報保存
    saveBrand: saveBrand,
    // ブランドを削除する
    deleteBrandById: deleteBrandById,
  }
}

/**
 * ブランドのSNSアカウント情報管理用のサービス
 * @param  {Function} Restangular Restangular
 * @param  {Function} $q Promise用
 * @return {Object} オブジェクト
 */
function EditBrandSnsModal(Restangular, $q) {
  /**
   * checkExistSnsAccount ユーザ名でSNSアカウントを取得してアカウントが存在するか確認
   * @param {brandId}  username ユーザ名
   * @return {Object} アカウント情報を取得
   */
  function checkExistSnsAccount(username: string, snsType: string) {
    let errorMessage = ''

    switch (snsType) {
      case 'facebook':
        username = username.replace('https://www.facebook.com/', '')
        break

      case 'twitter':
        username = username.replace('https://x.com/', '')
        break

      case 'instagram':
        username = username.replace('https://www.instagram.com/', '')
        break

      case 'tiktok':
        username = username.replace('https://www.tiktok.com/@', '')
        break

      case 'line':
        // URLの形式をチェック
        if (
          username.indexOf('https://') === 0 &&
          username.indexOf('https://timeline.line.me/user/') === -1 &&
          username.indexOf('https://timeline.line.me/post/') === -1
        ) {
          errorMessage = 'URLの形式が不正です。'
        } else {
          // usernameまたはchannelIdをゲット
          username = username.replace('https://timeline.line.me/user/', '')
          username = username.replace('https://timeline.line.me/post/', '')
        }
        break
    }
    if (username.indexOf('/') !== -1) {
      username = username.substring(0, username.indexOf('/'))
    }
    if (username.indexOf('?') !== -1) {
      username = username.substring(0, username.indexOf('?'))
    }

    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()

    // エラーメッセージがある場合は、リターンする
    if (errorMessage) {
      deferred.resolve({
        accountData: null,
        status: false,
        errorMessage: errorMessage,
      })

      return deferred.promise
    }

    // エラーメッセージがない場合は、APIでチェック
    const getUrl = `/brand/getAccountByApi?snsType=${snsType}&username=${username}`

    // 選択したユーザ名でをアカウント情報を確認
    Restangular.all(getUrl)
      .getList()
      .then((result) => {
        deferred.resolve(result[0])
      })

    // promiseの結果を返す
    return deferred.promise
  }

  /**
   * 対象ブランドのSNSアカウント情報を保存
   * @param accountInfo SNSアカウント情報
   * @return サーバーからの結果
   */
  function saveSnsAccount(accountInfo) {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()
    // POST用のリンクをセット
    const saveUrl = '/brand/saveSnsAccount'

    Restangular.all(saveUrl)
      .post(accountInfo)
      .then((result) => {
        // エラーがない場合
        if (result[0].data.error === undefined) {
          deferred.resolve(result[0].data)
        } else {
          deferred.reject(result[0].data.error)
        }
      })
    // promiseの結果を返す
    return deferred.promise
  }

  /**
   * ブランドのSnsアカウントを削除
   * @param accountId アカウントId
   * @param snsType SNSタイプ
   * @return サーバーからの結果
   */
  function deleteSnsAccount(accountId: number, snsType: string) {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()
    // POST用のデータをセット
    const postData = {
      accountId: accountId,
      snsType: snsType,
    }

    const postUrl = '/brand/deleteSnsAccount'

    Restangular.all(postUrl)
      .post(postData)
      .then((result) => {
        if (result[0].data.error === undefined) {
          deferred.resolve(result)
        }
      })
    // promiseの結果を返す
    return deferred.promise
  }

  /**
   * ブランドのデータ取得フラグを更新
   * @param accountId アカウントId
   * @param snsType 対象SNS
   * @return サーバーからの結果
   */
  function setDataFlg(accountId: number, targetSns: string) {
    // Promise用にdeferredオブジェクトを作成
    const deferred = $q.defer()
    // POST用のリンクをセット
    const saveUrl = '/brand/setDataFlg'
    // POST用のデータをセット
    const postData = {
      accountId: accountId,
      targetSns: targetSns,
    }

    Restangular.all(saveUrl)
      .post(postData)
      .then((result) => {
        // エラーがない場合
        if (result[0].data.error === undefined) {
          deferred.resolve(result[0].data)
        } else {
          deferred.reject(result[0].data.error)
        }
      })
    // promiseの結果を返す
    return deferred.promise
  }

  return {
    // ユーザ名でSNSアカウントを取得してアカウントが存在するか確認
    checkExistSnsAccount: checkExistSnsAccount,
    // ブランドにSNSアカウント情報を保存
    saveSnsAccount: saveSnsAccount,
    // ブランドのSNSアカウントを削除
    deleteSnsAccount: deleteSnsAccount,
    // ブランドのデータ取得フラグを更新
    setDataFlg: setDataFlg,
  }
}

/**
 *  ブランド管理モーダル用のサービスを1つのサービスにオブジェクトとして格納
 * @param {Function} EditBrandModal ブランド情報管理用のサービス
 * @return {Object} サービスのオブジェクト
 */
function EditBrandModalService(EditBrandModal, EditBrandSnsModal) {
  return {
    // ブランド管理用のサービス
    Brand: EditBrandModal,
    // ブランドのSNSアカウント管理用のサービス
    BrandSns: EditBrandSnsModal,
  }
}

// ブランド管理モーダル用のサービスを定義
app
  .factory('EditBrandModal', EditBrandModal)
  .factory('EditBrandSnsModal', EditBrandSnsModal)
  .factory('EditBrandModalService', EditBrandModalService)
